import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { ContentApiService } from './content-api.service';

// Permalink /post/<id> -> redirect to the landing content page with the post id as fragment
export const postLinkGuard: CanActivateFn = (route) => {
    const router = inject(Router);
    return inject(ContentApiService).locatePost$(route.paramMap.get('id') ?? '').pipe(
        map(location => location
            ? router.createUrlTree([location.landingPath], { fragment: location.postId })
            : true),
    );
};
